var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.isChecked) ? _c('v-font-icon', {
    class: _vm.theme.isChecked
  }, [_vm._v("check_box")]) : _c('v-font-icon', [_vm._v("check_box_outline_blank")])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72a45c0a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/Checkbox/CheckboxRaw.vue
// module id = 532
// module chunks = 0